import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgrxSyncStorageService } from './ngrx-sync-storage.service';
import { NgRxStorageSyncConfig } from './ngrx-sync-storage-config.interface';
import { provideSyncConnect } from './provide-sync-connect';

@NgModule({})
export class NgrxSyncStorageModule {
  static forFeature(config: NgRxStorageSyncConfig): ModuleWithProviders<NgrxSyncStorageModule> {
    return {
      ngModule: NgrxSyncStorageModule,
      providers: [
        NgrxSyncStorageService,
        provideSyncConnect(config)
      ],
    };
  }
}
